import { makeAutoObservable } from "mobx";

export class PlatformHomeModel {
  spaceIdInput = "";
  entranceError: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSpaceIdInput(v: string) {
    this.spaceIdInput = v.replace(/\D/g, "").slice(0, 8);
    this.entranceError = null;
  }

  setEntranceError(msg: string | null) {
    this.entranceError = msg;
  }
}

export type { RandomSpaceAccessPublicConfig } from "./PlatformHomeType";
